import { render, staticRenderFns } from "./ProductContentProductSelect.vue?vue&type=template&id=6610ad9c&"
import script from "./ProductContentProductSelect.vue?vue&type=script&lang=js&"
export * from "./ProductContentProductSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports